import React, { useContext } from 'react';
import { UtilsBlock, TextLarge, Icon, Image, Title4, Carousel } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-internal/js-react-i18n';
import EnvironmentContext from '../../../contexts/EnvironmentContext';

import Classes from './SellHighlightOptions.module.scss';

const OPTION_KEYS = ['homepageAd', 'dagtopper', 'directOmhoog'] as const;

const SellHighlightOptions = () => {
  const { t } = useI18nContext();
  const {
    links: { imageSources },
  } = useContext(EnvironmentContext);

  return (
    <>
      <UtilsBlock mb={['m', 'xl', null]} className={Classes.header}>
        <UtilsBlock as="h5" textStyle={['title-4', null, 'title-2']} mb="xxs">
          <span className="Title-highlight">{t('sell.page.highlightOptions.titleHighlight')}</span>
          <span>{t('sell.page.highlightOptions.title')}</span>
        </UtilsBlock>
        <TextLarge color="text-secondary">{t('sell.page.highlightOptions.subtitle')}</TextLarge>
      </UtilsBlock>
      <Carousel title="" className="contentCarousel">
        {OPTION_KEYS.map((key) => (
          <article key={key} className={`PageContent-card ${Classes.card}`}>
            <Image
              className={Classes.image}
              src={imageSources[key]}
              alt=""
              fetchPriority="auto"
              // @ts-expect-error -- DS issue
              aspectRatio=""
            />
            <Title4 as="h5" utilities={['marginBottomM']} className={Classes.cardTitle}>
              {t(`sell.page.highlightOptions.${key}.title`)}
            </Title4>
            <ul className={Classes.benefits}>
              <li className={Classes.benefit}>
                <Icon name="checkmark" color="text-success" />
                <TextLarge color="text-secondary">{t(`sell.page.highlightOptions.${key}.benefit1`)}</TextLarge>
              </li>
              <li className={Classes.benefit}>
                <Icon name="checkmark" color="text-success" />
                <TextLarge color="text-secondary">{t(`sell.page.highlightOptions.${key}.benefit2`)}</TextLarge>
              </li>
            </ul>
          </article>
        ))}
      </Carousel>
    </>
  );
};

export default SellHighlightOptions;
